// Đích quay về sau đăng nhập (SAA-2026-011 D6). `?next=` sống trên URL; link xác minh email mở ở TAB KHÁC nên đích còn
// được nhớ trong localStorage (cùng origin) — tối đa 1 ngày, đọc xong xoá. Chỉ nhận đường dẫn cùng origin.
const KEY = "saa_return_to";
const TTL_MS = 86_400_000;

/** `/…` cùng origin; chặn `//host`, `/\host` (open redirect) và mọi URL tuyệt đối. */
export function safeNext(raw: string | null | undefined): string | null {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return null;
  return raw;
}

/** `/login` + `?next=` (nếu có) — giữ đích khi chuyển giữa đăng nhập / đăng ký / xác minh. */
export function withNext(path: string, next: string | null, extra: Record<string, string> = {}): string {
  const q = new URLSearchParams(extra);
  const safe = safeNext(next);
  if (safe) q.set("next", safe);
  const s = q.toString();
  return s ? `${path}?${s}` : path;
}

export function rememberReturnTo(next: string | null): void {
  const safe = safeNext(next);
  if (!safe) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ path: safe, at: Date.now() }));
  } catch {
    // trình duyệt chặn localStorage: đích chỉ còn trên URL; lời mời vẫn hiện ở « Lời mời đang chờ »
  }
}

export function takeReturnTo(now = Date.now()): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as { path?: unknown; at?: unknown };
    if (typeof v.path !== "string" || typeof v.at !== "number" || now - v.at > TTL_MS) return null;
    return safeNext(v.path);
  } catch {
    // localStorage bị chặn hoặc giá trị hỏng: coi như không có đích nhớ
    return null;
  }
}
